'use client';

import { Button, ButtonVariant } from '@/components/ui/button';
import { Colors } from '@/lib/colorUtils';
import { cn } from '@/lib/styleUtils';
import { AccountNavigationProps } from './AccountNavigation.types';
import { Text } from '@/components/ui/text';

export const MobileNavigation = ({
  items,
  activeItemId,
  onItemClick,
  className,
}: AccountNavigationProps) => {
  return (
    <nav
      className={cn(
        'tw:flex tw:w-full tw:border-0 tw:border-t tw:border-solid tw:border-gray-light tw:px-nano tw:pt-nano tw:pb-huge',
        className
      )}
    >
      <div className="tw:flex tw:w-full tw:justify-around tw:items-center">
        {items.map((item) => {
          const isActive = item.id === activeItemId;
          return (
            <Button
              variant={ButtonVariant.secondary}
              key={item.id}
              onClick={() => {
                if (item.onClick) item.onClick();
                if (onItemClick) onItemClick(item.id);
              }}
              className={cn(
                'tw:flex tw:flex-col tw:items-center tw:justify-center tw:border-none tw:shadow-none tw:py-micro tw:transition-all tw:rounded-8',
                isActive ? 'tw:bg-primary-light' : 'tw:bg-transparent'
              )}
              data-cy="mobile-navigation-item"
            >
              <div className="tw:flex tw:flex-col tw:items-center tw:gap-nano">
                {item.icon}
                <Text
                  size="14"
                  weight="regular"
                  color={Colors.colorGrayDarker}
                  lineHeight="3"
                  data-cy="mobile-navigation-item-label"
                >
                  {item.label}
                </Text>
              </div>
            </Button>
          );
        })}
      </div>
    </nav>
  );
};
